import api from './api';

export const pmService = {
  // Maintenance Plans
  getMaintenancePlans: (params) => api.get('/pm/api/maintenance-plans/', { params }),
  getMaintenancePlan: (id) => api.get(`/pm/api/maintenance-plans/${id}/`),
  createMaintenancePlan: (data) => api.post('/pm/api/maintenance-plans/', data),
  updateMaintenancePlan: (id, data) => api.put(`/pm/api/maintenance-plans/${id}/`, data),
  deleteMaintenancePlan: (id) => api.delete(`/pm/api/maintenance-plans/${id}/`),
  getMaintenancePlanTasks: (planId) => api.get(`/pm/api/maintenance-plans/${planId}/tasks/`),

  // Maintenance Schedules
  getMaintenanceSchedules: (params) => api.get('/pm/api/maintenance-schedules/', { params }),
  getMaintenanceSchedule: (id) => api.get(`/pm/api/maintenance-schedules/${id}/`),
  createMaintenanceSchedule: (data) => api.post('/pm/api/maintenance-schedules/', data),
  updateMaintenanceSchedule: (id, data) => api.put(`/pm/api/maintenance-schedules/${id}/`, data),
  deleteMaintenanceSchedule: (id) => api.delete(`/pm/api/maintenance-schedules/${id}/`),

  // Breakdown Reports
  getBreakdownReports: (params) => api.get('/pm/api/breakdown-reports/', { params }),
  getBreakdownReport: (id) => api.get(`/pm/api/breakdown-reports/${id}/`),
  createBreakdownReport: (data) => api.post('/pm/api/breakdown-reports/', data),
  updateBreakdownReport: (id, data) => api.put(`/pm/api/breakdown-reports/${id}/`, data),
  deleteBreakdownReport: (id) => api.delete(`/pm/api/breakdown-reports/${id}/`),

  // Emergency Work Orders
  getEmergencyWorkOrders: (params) => api.get('/pm/api/emergency-work-orders/', { params }),
  getEmergencyWorkOrder: (id) => api.get(`/pm/api/emergency-work-orders/${id}/`),
  createEmergencyWorkOrder: (data) => api.post('/pm/api/emergency-work-orders/', data),
  updateEmergencyWorkOrder: (id, data) => api.put(`/pm/api/emergency-work-orders/${id}/`, data),
  deleteEmergencyWorkOrder: (id) => api.delete(`/pm/api/emergency-work-orders/${id}/`),

  // Equipment Health
  getEquipmentHealth: (params) => api.get('/pm/api/equipment-health/', { params }),
  getEquipmentHealthDetail: (id) => api.get(`/pm/api/equipment-health/${id}/`),

  // Anomalies
  getAnomalies: (params) => api.get('/pm/api/anomalies/', { params }),
  getAnomaly: (id) => api.get(`/pm/api/anomalies/${id}/`),
  createAnomaly: (data) => api.post('/pm/api/anomalies/', data),
  updateAnomaly: (id, data) => api.put(`/pm/api/anomalies/${id}/`, data),
  deleteAnomaly: (id) => api.delete(`/pm/api/anomalies/${id}/`),

  // Failure Predictions
  getFailurePredictions: (params) => api.get('/pm/api/failure-predictions/', { params }),
  getFailurePrediction: (id) => api.get(`/pm/api/failure-predictions/${id}/`),
  createFailurePrediction: (data) => api.post('/pm/api/failure-predictions/', data),
  updateFailurePrediction: (id, data) => api.put(`/pm/api/failure-predictions/${id}/`, data),
  deleteFailurePrediction: (id) => api.delete(`/pm/api/failure-predictions/${id}/`),

  // Equipment Specifications
  getEquipmentSpecifications: (params) => api.get('/pm/api/equipment-specifications/', { params }),
  getEquipmentSpecification: (id) => api.get(`/pm/api/equipment-specifications/${id}/`),
  createEquipmentSpecification: (data) => api.post('/pm/api/equipment-specifications/', data),
  updateEquipmentSpecification: (id, data) => api.put(`/pm/api/equipment-specifications/${id}/`, data),
  deleteEquipmentSpecification: (id) => api.delete(`/pm/api/equipment-specifications/${id}/`),

  // Equipment Operating Parameters
  getEquipmentParameters: (params) => api.get('/pm/api/equipment-parameters/', { params }),
  getEquipmentParameter: (id) => api.get(`/pm/api/equipment-parameters/${id}/`),
  createEquipmentParameter: (data) => api.post('/pm/api/equipment-parameters/', data),
  updateEquipmentParameter: (id, data) => api.put(`/pm/api/equipment-parameters/${id}/`, data),
  deleteEquipmentParameter: (id) => api.delete(`/pm/api/equipment-parameters/${id}/`),

  // Condition Readings
  getConditionReadings: (params) => api.get('/pm/api/condition-readings/', { params }),
  getConditionReading: (id) => api.get(`/pm/api/condition-readings/${id}/`),
  createConditionReading: (data) => api.post('/pm/api/condition-readings/', data),
  updateConditionReading: (id, data) => api.put(`/pm/api/condition-readings/${id}/`, data),
  deleteConditionReading: (id) => api.delete(`/pm/api/condition-readings/${id}/`),

  // Maintenance Tasks
  getMaintenanceTasks: (params) => api.get('/pm/api/maintenance-tasks/', { params }),
  getMaintenanceTask: (id) => api.get(`/pm/api/maintenance-tasks/${id}/`),
  createMaintenanceTask: (data) => api.post('/pm/api/maintenance-tasks/', data),
  updateMaintenanceTask: (id, data) => api.put(`/pm/api/maintenance-tasks/${id}/`, data),
  deleteMaintenanceTask: (id) => api.delete(`/pm/api/maintenance-tasks/${id}/`),

  // Maintenance Task Executions
  getTaskExecutions: (params) => api.get('/pm/api/task-executions/', { params }),
  getTaskExecution: (id) => api.get(`/pm/api/task-executions/${id}/`),
  createTaskExecution: (data) => api.post('/pm/api/task-executions/', data),
  updateTaskExecution: (id, data) => api.put(`/pm/api/task-executions/${id}/`, data),
  deleteTaskExecution: (id) => api.delete(`/pm/api/task-executions/${id}/`),

  // Maintenance Resources
  getMaintenanceResources: (params) => api.get('/pm/api/maintenance-resources/', { params }),
  getMaintenanceResource: (id) => api.get(`/pm/api/maintenance-resources/${id}/`),
  createMaintenanceResource: (data) => api.post('/pm/api/maintenance-resources/', data),
  updateMaintenanceResource: (id, data) => api.put(`/pm/api/maintenance-resources/${id}/`, data),
  deleteMaintenanceResource: (id) => api.delete(`/pm/api/maintenance-resources/${id}/`),

  // Work Order Labor
  getWorkOrderLabor: (params) => api.get('/pm/api/work-order-labor/', { params }),
  getWorkOrderLaborEntry: (id) => api.get(`/pm/api/work-order-labor/${id}/`),
  createWorkOrderLaborEntry: (data) => api.post('/pm/api/work-order-labor/', data),
  updateWorkOrderLaborEntry: (id, data) => api.put(`/pm/api/work-order-labor/${id}/`, data),
  deleteWorkOrderLaborEntry: (id) => api.delete(`/pm/api/work-order-labor/${id}/`),

  // Work Order Parts
  getWorkOrderParts: (params) => api.get('/pm/api/work-order-parts/', { params }),
  getWorkOrderPart: (id) => api.get(`/pm/api/work-order-parts/${id}/`),
  createWorkOrderPart: (data) => api.post('/pm/api/work-order-parts/', data),
  updateWorkOrderPart: (id, data) => api.put(`/pm/api/work-order-parts/${id}/`, data),
  deleteWorkOrderPart: (id) => api.delete(`/pm/api/work-order-parts/${id}/`),

  // Defect Analyses
  getDefectAnalyses: (params) => api.get('/pm/api/defect-analyses/', { params }),
  getDefectAnalysis: (id) => api.get(`/pm/api/defect-analyses/${id}/`),
  createDefectAnalysis: (data) => api.post('/pm/api/defect-analyses/', data),
  updateDefectAnalysis: (id, data) => api.put(`/pm/api/defect-analyses/${id}/`, data),
  deleteDefectAnalysis: (id) => api.delete(`/pm/api/defect-analyses/${id}/`),

  // Failure History
  getFailureHistory: (params) => api.get('/pm/api/failure-history/', { params }),
  getFailureHistoryEntry: (id) => api.get(`/pm/api/failure-history/${id}/`),
  createFailureHistoryEntry: (data) => api.post('/pm/api/failure-history/', data),
  updateFailureHistoryEntry: (id, data) => api.put(`/pm/api/failure-history/${id}/`, data),
  deleteFailureHistoryEntry: (id) => api.delete(`/pm/api/failure-history/${id}/`),

  // Predictive Models
  getPredictiveModels: (params) => api.get('/pm/api/predictive-models/', { params }),
  getPredictiveModel: (id) => api.get(`/pm/api/predictive-models/${id}/`),
  createPredictiveModel: (data) => api.post('/pm/api/predictive-models/', data),
  updatePredictiveModel: (id, data) => api.put(`/pm/api/predictive-models/${id}/`, data),
  deletePredictiveModel: (id) => api.delete(`/pm/api/predictive-models/${id}/`),

  // Dashboard
  getDashboard: () => api.get('/pm/api/dashboard/'),

  // Shop-floor breakdown flow (mobile, /pm/breakdown-mobile)
  getBreakdownQueue: (scope) => api.get('/pm/api/breakdown-flow/', { params: { scope } }),
  getBreakdownFlow: (id) => api.get(`/pm/api/breakdown-flow/${id}/`),
  lookupBreakdownEquipment: (code) => api.get('/pm/api/breakdown-flow/lookup-equipment/', { params: { code } }),
  lookupBreakdownOperator: (code) => api.get('/pm/api/breakdown-flow/lookup-operator/', { params: { code } }),
  // Always FormData (an optional photo rides along); the client default is JSON.
  reportBreakdown: (formData) => api.post('/pm/api/breakdown-flow/report/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  getBreakdownEngineers: () => api.get('/pm/api/breakdown-flow/engineers/'),
  assignBreakdown: (id, engineer) => api.post(`/pm/api/breakdown-flow/${id}/assign/`, { engineer }),
  acknowledgeBreakdown: (id) => api.post(`/pm/api/breakdown-flow/${id}/acknowledge/`),
  // Phase 2: classification (common hierarchy PMBDC), work order, repair
  getBreakdownClassification: () => api.get('/pm/api/breakdown-flow/classification-catalogue/'),
  classifyBreakdown: (id, data) => api.post(`/pm/api/breakdown-flow/${id}/classify/`, data),
  startBreakdownRepair: (id) => api.post(`/pm/api/breakdown-flow/${id}/start-repair/`),
  // Phase 3: spares, PR, external service
  searchBreakdownMaterials: (q) => api.get('/pm/api/breakdown-flow/materials/', { params: { q } }),
  requestBreakdownSpares: (id, data) => api.post(`/pm/api/breakdown-flow/${id}/request-spares/`, data),
  raiseBreakdownSparesPr: (id, reservation) => api.post(`/pm/api/breakdown-flow/${id}/spares-pr/`, { reservation }),
  cancelBreakdownSpare: (id, reservation, reason) => api.post(`/pm/api/breakdown-flow/${id}/cancel-spare/`, { reservation, reason }),
  searchBreakdownSuppliers: (q) => api.get('/pm/api/breakdown-flow/suppliers/', { params: { q } }),
  requestBreakdownExternalService: (id, data) => api.post(`/pm/api/breakdown-flow/${id}/request-external-service/`, data),
  // Phase 4: fixed -> operator check -> supervisor confirmation
  markBreakdownFixed: (id, data) => api.post(`/pm/api/breakdown-flow/${id}/mark-fixed/`, data),
  breakdownOperatorCheck: (id, data) => api.post(`/pm/api/breakdown-flow/${id}/operator-check/`, data),
  confirmBreakdown: (id, data) => api.post(`/pm/api/breakdown-flow/${id}/confirm/`, data),
  // Stores
  getSparesToIssue: (status = 'open') => api.get('/pm/api/spares-issue/', { params: { status } }),
  getSpareStock: (reservationId) => api.get(`/pm/api/spares-issue/${reservationId}/stock/`),
  getSparesCostCenters: () => api.get('/pm/api/spares-issue/cost-centers/'),
  issueSpare: (reservationId, data) => api.post(`/pm/api/spares-issue/${reservationId}/issue/`, data),
};
